import { Injectable } from '@angular/core';
import { AbstractMessageCommand } from 'flux-connection';
import { Command, CommandInterfaces, StateService } from 'flux-core';
import { DataStore } from 'flux-store';
import { Observable, of } from 'rxjs';

@Injectable()
@Command()
export class GetProjectsAndDiagramsCommand extends AbstractMessageCommand {

    public static get implements(): Array<CommandInterfaces> {
        return [
            'IMessageCommand',
            'IProjectCommand',
        ];
    }

    constructor( protected stateService: StateService<any, any>,
                 protected dataStore: DataStore ) {
        super()/* istanbul ignore next */;
    }

    public get version(): number {
        return 1;
    }

    public execute(): boolean {
        return true;
    }

    public executeResult( response: any ): Observable<any> {
        const projectDiagrams = {} as any;
        const projectMap = {} as any;

        const defaultProject = response.projects?.find((p: any) => p?.isDefault );

        if ( defaultProject ) {
            const reassignedDiagrams = response.diagrams?.map((d: any) =>
                d?.project === defaultProject.id ? { ...d, project: 'home' } : d,
            ) || [];

            const filteredProjects = response.projects.filter((p: any) => p.id !== defaultProject.id );

            response.projects = filteredProjects;
            response.diagrams = reassignedDiagrams;
        }

        (response.projects || []).forEach((project: any) => {
            const projId = project.id;
            projectMap[projId] = project;
            projectDiagrams[projId] = (response.diagrams || []).filter((d: any) => d.project === projId );
        });

        this.stateService.set( 'ProjectDiagrams', projectDiagrams );
        this.stateService.set( 'ProjectMap', projectMap );
        return of( true );
    }
}

Object.defineProperty( GetProjectsAndDiagramsCommand, 'name', {
    value: 'GetProjectsAndDiagramsCommand',
});
